import React, { useState } from "react"
import Swal from 'sweetalert2'
import { loginUser } from "../../services/login.service"
import { useDispatch, useSelector } from 'react-redux';
import { loginRequest } from "../../config/authConfig";
import { userActions } from "../../store/user";
import { AuthenticatedTemplate, UnauthenticatedTemplate, useMsal } from "@azure/msal-react";
import { showError, showInfo } from "../../utils/alertsUtils";

export const LoginForm = (props) => {
    const { instance } = useMsal()

    const user = useSelector(state => state.user)
    const dispatch = useDispatch()

    const handleLogin = async (e) => {
        instance.loginRedirect(loginRequest)
            .then(async data => {
                const login = await loginUser(data.access_token)
                const response = login.data
                if(login.status !== 200){
                    showError('Something Went Wrong!');
                }else if(response.error){
                    showError(response.error);
                }
                else{
                    if(response.activeSession){
                        showInfo('You had an active session!');
                    }
                    setTimeout(()=>{
                        dispatch(userActions.login(response));
                    },3000)
                }
            }).catch((e) => {
                console.error(e);
                showError('Something Went Wrong!');
            });
    }

    return (
    
        <div className="col-lg-3">
            <h2 className="card-title font-weight-500 mt-md-3 mt-1">
                <span className="star-orange">LOGIN</span> TO ACCESS
            </h2>
            <a
                className="btn btn-primary btn-lg rounded-10 mb-2" onClick={handleLogin}
            >
                Login
            </a>
            <p
                className="text-starshot font-lato font-weight-600 d-lg-none"
                data-toggle="modal"
                data-target="#wis"
                role="button"
            >
                WHAT IS STARSHOT?
            </p>
            <div className="d-none d-lg-block">
                <p className="font-lato login-text mb-1">
                    Imagine a paperclip, a mere object lying on your desk in
                    abundance and helping you organize sheaves of paper. Back in the
                    1800s, it was invented out of necessity, and voila, it changed
                    the story.
                </p>
                <p className="font-lato login-text mb-1">
                    In today’s world, can we think of communication, both personal
                    and professional, without emails? MCI Mail was a novel idea in
                    1983, and even after it became defunct, the underlying
                    technology influenced key email products, including the widely
                    used Gmail. Think about the USB stick in your wallet. Invented
                    in 1996, the USB stick has become a convenient standard type of
                    connection to transfer and transport your documents.
                </p>
                <p className="font-lato login-text star-orange">
                    At Starshot, we aim to solve tomorrow’s problems using today’s
                    technology - without boundaries
                </p>
            </div>
            <div className="footer-login">
                <p className="mb-0 star-light">
                    ©2025 Protiviti Inc. All Rights Reserved.
                </p>
                <p className="mb-0 star-light d-lg-none">
                    Protiviti Inc. is an Equal Opportunity Employer,
                </p>
                <p className="mb-0 star-light d-lg-none">M/F/Disability/Ve</p>
            </div>
        </div>
    )
}